import { useState } from 'react';
import { menuData } from '../../../mocks/menu';

export default function Menu() {
  const [activeCategory, setActiveCategory] = useState('poissons');

  const categories = [
    { id: 'poissons', label: 'Poissons & Fruits de mer', icon: 'ri-fish-line' },
    { id: 'viandes', label: 'Viandes', icon: 'ri-restaurant-2-line' },
    { id: 'signature', label: 'Signature', icon: 'ri-star-line' },
    { id: 'desserts', label: 'Desserts', icon: 'ri-cake-3-line' }
  ];

  return (
    <section id="menu-section" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/30 via-stone-50 to-emerald-50/30"></div>
    </section>
  );
}
